export default __webpack_public_path__ + "13800082e4cdf8128c51645c03627450.png";